<template>
  <div class="content-quiz-body-markup">
    <h2 class="question" v-html="question.content"></h2>
    <div v-if="question.rationale && showRationale" class="question-rationale">
      <b>Rationale:</b>
      <p v-html="question.rationale"></p>
    </div>
    <answers @answerClicked="onAnswerClicked" :answers="question.options" :multiselect="question.multiselect" />
  </div>
</template>
<script>
import Answers from "./answers"
export default {
  components: {
    Answers
  },
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showRationale: false
    }
  },

  methods: {
    onAnswerClicked() {
      this.showRationale = true
    }
  }
}
</script>
